var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 111.856 90.407",
    strokeWidth: 2.2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1481 -301.763)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1482.5 303.263)"
  }, /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    x2: 74.212,
    transform: "translate(0 52.411)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "currentColor",
    width: 63.985,
    height: 47.43,
    transform: "translate(4.818 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1561.156 345.025)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M28.022,46.645H9.886C7.74,46.645,6,44.6,6,42.08V5.564C6,3.044,7.74,1,9.886,1H28.022c2.146,0,3.886,2.044,3.886,4.564V42.08c0,2.521-1.74,4.564-3.886,4.564Z",
    transform: "translate(-6 -1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    cx: 2.203,
    cy: 2.246,
    rx: 2.203,
    ry: 2.246,
    transform: "translate(5.283 4.491)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M0,0A36.618,36.618,0,0,1,33.906,23.632",
    transform: "translate(1557.294 307.423) rotate(10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M0,0A36.3,36.3,0,0,1,33.81,23.534",
    transform: "translate(1547.52 387.839) rotate(180)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDevice);
export default __webpack_public_path__ + "static/media/switch-device.3b9408ab.svg";
export { ForwardRef as ReactComponent };